import { createSlice } from "@reduxjs/toolkit";
import { CareCommentAnalysisDataJson } from "../../../../domain/care_comment_analysis/CareCommentAnalysisData";
import { DateObject } from "../../../../domain/fundamental/DateObject";
import { ActionType, dateSearchAction, getListAction } from "./actions";

export type AdminCareCommentAnalysisState = Readonly<{
    analysisDataList: CareCommentAnalysisDataJson[],
    searchedAnalysisDataList: {
        list: CareCommentAnalysisDataJson[],
        registerDateStart: string,
        registerDateEnd: string
    },
    processing: number
}>;

const careCommentAnalysisInitialState: AdminCareCommentAnalysisState = {
    analysisDataList: [],
    searchedAnalysisDataList: {
        list: [],
        registerDateStart: "",
        registerDateEnd: ""
    },
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: careCommentAnalysisInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getListAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getListAction.fulfilled,
                (state, action) => {
                    const { analysisDataList } = action.payload;
                    state.analysisDataList = analysisDataList;
                    state.searchedAnalysisDataList = {
                        list: analysisDataList,
                        registerDateStart: "",
                        registerDateEnd: ""
                    };
                    state.processing -= 1;
                }
            )
            .addCase(
                getListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                dateSearchAction.fulfilled,
                (state, action) => {
                    const { registerDateStart, registerDateEnd } = action.payload;

                    const list = searchAnalysisDataList(state.analysisDataList, registerDateStart, registerDateEnd);

                    state.searchedAnalysisDataList = {
                        list: list,
                        registerDateStart: registerDateStart,
                        registerDateEnd: registerDateEnd
                    };
                }
            );
    }
});

const searchAnalysisDataList = (
    analysisDataList: CareCommentAnalysisDataJson[],
    registerDateStart: string,
    registerDateEnd: string
) => {
    const listSearchedByStartDate = registerDateStart
        ? analysisDataList.filter(analysisData => DateObject.fromString(analysisData.createdTime).isEqualsOrGreaterThan(DateObject.fromString(registerDateStart)))
        : analysisDataList;
    const listSearchedByEndDate = registerDateEnd
        ? listSearchedByStartDate.filter(analysisData => DateObject.fromString(analysisData.createdTime).isEqualsOrLessThan(DateObject.fromString(registerDateEnd)))
        : listSearchedByStartDate;
    return listSearchedByEndDate;
};

export const adminCareCommentAnalysisReducer = slice.reducer;
